<template>
    <path fill-rule="evenodd" d="M22.55 16.562c-.042-4.172 3.425-6.173 3.58-6.272-1.948-2.831-4.982-3.219-6.063-3.264-2.582-.26-5.038 1.51-6.349 1.51-1.307 0-3.33-1.472-5.47-1.433-2.815.042-5.41 1.625-6.86 4.13-2.924 5.04-.749 12.509 2.102 16.596 1.393 2.002 3.053 4.25 5.233 4.169 2.1-.083 2.894-1.35 5.433-1.35 2.538 0 3.252 1.35 5.473 1.308 2.26-.042 3.69-2.04 5.074-4.047 1.6-2.321 2.258-4.57 2.297-4.685-.05-.023-4.406-1.68-4.45-6.663v.001zm-5.383-11.72C18.372 3.56 19.186 1.777 18.963 0c-1.736.062-3.84 1.016-5.086 2.297-1.118 1.136-2.096 2.95-1.834 4.691 1.938.133 3.916-.865 5.123-2.146z"/>
</template>

<script>
export default {
    name: 'iosIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 27 32');
    }
};
</script>
